import { render, staticRenderFns } from "./CreateNewRule.vue?vue&type=template&id=308661db&scoped=true"
import script from "./CreateNewRule.vue?vue&type=script&lang=ts"
export * from "./CreateNewRule.vue?vue&type=script&lang=ts"
import style0 from "./CreateNewRule.vue?vue&type=style&index=0&id=308661db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308661db",
  null
  
)

export default component.exports